import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { autoFormatEnergyValue } from "@solarschools/component-lib/src/utilities/EnergyUnits";
import { autoFormatMassValue } from "../../../utilities/UnitsAndKeys/MassUnits";

export const LifetimeStatistics = ({
  totalEnergyGenerated,
  totalCo2Saved,
  totalWaterSaved,
  totalGridConsumption,
  totalEmissions,
}) => {
  return (
    <div className="flex-grow-1 d-flex flex-column align-items-stretch justify-content-around h-100">
      {!totalEnergyGenerated &&
        !totalGridConsumption &&
        !totalCo2Saved &&
        !totalEmissions && (
          <div className="stat-row">No lifetime data available</div>
        )}
      {!totalEnergyGenerated ? null : (
        <div className="stat-row">
          <strong>{autoFormatEnergyValue(totalEnergyGenerated)}</strong> Solar
          Generation
        </div>
      )}
      {!totalGridConsumption ? null : (
        <div className="stat-row">
          <strong>{autoFormatEnergyValue(totalGridConsumption)}</strong> of Grid
          Consumption
        </div>
      )}
      {!totalCo2Saved ? null : (
        <div className="stat-row">
          <strong>{autoFormatMassValue(totalCo2Saved)}</strong> Total CO
          <sub>2</sub>
          -e Avoided
        </div>
      )}
      {!totalEmissions ? null : (
        <div className="stat-row">
          <strong>{autoFormatMassValue(totalEmissions)}</strong> of CO
          <sub>2</sub>
          -e Emitted
        </div>
      )}
      {!totalWaterSaved ? null : (
        <div className="stat-row">
          <strong>
            {(totalWaterSaved / 1000).toFixed(2)}
            kL
          </strong>{" "}
          of Lifetime Water Savings
        </div>
      )}
    </div>
  );
};

LifetimeStatistics.propTypes = {
  totalEnergyGenerated: PropTypes.number.isRequired,
  totalCo2Saved: PropTypes.number.isRequired,
  totalGridConsumption: PropTypes.number.isRequired,
  totalEmissions: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/LifetimeStatistics/LifetimeStatistics.js